/**
 * Simple network test to debug what's available
 */

export const simpleNetworkTest = () => {
  console.log("=== SIMPLE NETWORK TEST ===");
  
  // Test 1: Basic browser info
  console.log("1. Basic Browser Info:");
  console.log("  navigator.onLine:", navigator.onLine);
  console.log("  navigator.userAgent:", navigator.userAgent);
  
  // Test 2: Connection API availability
  console.log("2. Connection API:");
  console.log("  navigator.connection:", navigator.connection);
  console.log("  navigator.mozConnection:", navigator.mozConnection);
  console.log("  navigator.webkitConnection:", navigator.webkitConnection);
  
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    console.log("  Connection object found:");
    console.log("    effectiveType:", connection.effectiveType);
    console.log("    downlink:", connection.downlink);
    console.log("    rtt:", connection.rtt);
    console.log("    saveData:", connection.saveData);
    console.log("    type:", connection.type);
  } else {
    console.log("  No connection API available");
  }
  
  // Test 3: Performance API
  console.log("3. Performance API:");
  console.log("  window.performance:", !!window.performance);
  console.log("  performance.now():", window.performance ? performance.now() : "not available");
  
  // Test 4: Simple object creation
  console.log("4. Simple Object Creation:");
  try {
    const testObj = {
      online: navigator.onLine,
      timestamp: new Date().toISOString(),
      connection_available: !!connection,
      connection_type: connection?.effectiveType || 'unknown'
    };
    console.log("  Test object:", testObj);
    return testObj;
  } catch (error) {
    console.error("  Error creating test object:", error);
    return { error: error.message };
  }
};

// Make it globally available
if (typeof window !== 'undefined') {
  window.simpleNetworkTest = simpleNetworkTest;
}

